import { render, staticRenderFns } from "./InstructionsDetailedProduce.vue?vue&type=template&id=485bbdfd&"
import script from "./InstructionsDetailedProduce.vue?vue&type=script&lang=js&"
export * from "./InstructionsDetailedProduce.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsDetailedProduce.vue?vue&type=style&index=0&id=485bbdfd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports